export default __webpack_public_path__ + "static/media/undo-arrow.fff5feb7.svg";